<svg name="details" class="chart details"></svg>
<h6 name="overviewTitle" class="overview-title" [hidden]="!shouldZoom()">
  Displaying <span class="zoom-title">{{ zoomTitle() }}</span> {{ zoomStart() }} -
  {{ zoomEnd() }}
</h6>
<svg name="overview" class="chart overview"></svg>
